import { render, staticRenderFns } from "./KBText.vue?vue&type=template&id=19ffad64&scoped=true&"
import script from "./KBText.vue?vue&type=script&lang=ts&"
export * from "./KBText.vue?vue&type=script&lang=ts&"
import style0 from "./KBText.vue?vue&type=style&index=0&id=19ffad64&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ffad64",
  null
  
)

export default component.exports